var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.plainLayout)?_c('Header'):_vm._e(),_vm._v(" "),_c('router-view',{style:({
      marginTop: !_vm.$route.meta.plainLayout ? '0' : '0',
      minHeight: '100vh',
      boxSizing: 'border-box',
    })}),_vm._v(" "),(!_vm.$route.meta.plainLayout)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94b358f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 